import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import StudentList from '@/pages/students/StudentList';
import StudentAdmission from '@/pages/students/StudentAdmission';
import BulkAdmission from '@/pages/students/BulkAdmission';
import StudentDetails from '@/pages/students/StudentDetails';
import FailedStudentManagement from '@/pages/students/FailedStudentManagement';

export const studentRoutes = (
  <React.Fragment>
    <Route path="students" element={<Navigate to="students/list" replace />} />
    <Route path="students/list" element={<StudentList />} />
    <Route path="students/admission" element={<StudentAdmission />} />
    <Route path="students/bulk-admission" element={<BulkAdmission />} />
    <Route path="students/failed-management" element={<FailedStudentManagement />} />
    <Route path="students/:id" element={<StudentDetails />} />
  </React.Fragment>
);
